import React, { useEffect, useRef, useState } from 'react'
import { Col, Form, Row } from 'react-bootstrap'
import moment from 'moment'

import { Controller, useForm } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup'
import * as yup from 'yup'
import Cleave from 'cleave.js/react'
import UseEmpsTitle from '../../../../../hooks/use-emps-titles'
import UseSexs from '../../../../../hooks/use-emps-sexs'
import UseNationalitys from '../../../../../hooks/use-emps-nationalitys'
import UseProvinces from '../../../../../hooks/use-adds-provinces'
import UseDistricts from '../../../../../hooks/use-adds-districts'
import UseSubdistricts from '../../../../../hooks/use-adds-subdistricts'
import useThaiInput from '../../../../../helper/input-fix-th'
import useEngInput from '../../../../../helper/input-fix-en'
import {
  getEmpsPersonalsAPI,
  updateEmpsPersonalsAPI
} from '../../../../../services/employee'
import {
  getDistrictsAPI,
  getSubdistrictsAPI
} from '../../../../../services/address'
import SwalCustom from '../../../../../alert/swal-custom'
import { TXTSUCCESS } from '../../../../../Constants'
import Error_false from '../../../../error/error-false'
import SwalLarkSyncWarning, {
  isLarkSyncWarning
} from '../../../../../alert/swal-lark-sync'
import { useTranslation } from 'react-i18next'
import ButtonSummit from '../_btn-summit'
import LabelCustomSmall from '../../../../label-custom-small'
import Autocomplete from '../../../../custom/autocomplete'
import DatepickerCustom from '../../../../datepicker-custom'
import InputNumber from '../../../../input-number'
import InputIDCardNumber from '../../../../input-idcard-num'
import CreatableSelectLicenseCustom from '../../../../CreatableSelectCustom'

const schema = yup
  .object({
    title_th: yup.object().required('กรุณาระบุคำนำหน้า'),
    name_th: yup.string().required('กรุณาระบุชื่อภาษาไทย'),
    surname_th: yup.string().required('กรุณาระบุนามสกุล'),
    nickname_th: yup.string().required('กรุณาระบุชื่อเล่น'),
    title_en: yup.object().required('กรุณาระบุคำนำหน้าภาษาอังกฤษ'),
    name_en: yup.string().required('กรุณาระบุชื่อภาษาอังกฤษ'),
    surname_en: yup.string().required('กรุณาระบุนามสกุลภาษาอังกฤษ'),
    nickname_en: yup.string().required('กรุณาระบุชื่อเล่นภาษาอังกฤษ'),
    birthday: yup.string().required('กรุณาระบุวันเกิด (ค.ศ.)'),
    sex: yup.object().required('กรุณาระบุเพศ'),
    nationality: yup.object().required('กรุณาระบุสัญชาติ'),
    id_card: yup.string().required('กรุณาระบุข้อมูล'),
    height: yup.number().positive().integer().required('กรุณาระบุส่วนสูง'),
    weight: yup.number().positive().integer().required('กรุณาระบุน้ำหนัก'),
    mobile: yup.string().required('กรุณาระบุเบอร์มือถือ'),
    // personalemail: yup.string().required('กรุณาระบุ e-mail'),
    address_home: yup.string().required('กรุณาระบุที่อยู่ตามทะเบียนบ้าน'),
    province_home: yup.object().required('กรุณาระบุจังหวัด'),
    district_home: yup.object().required('กรุณาระบุเขต / อำเภอ'),
    sub_district_home: yup.object().required('กรุณาระบุแขวง / ตำบล '),
    post_code_home: yup.string().required('กรุณาระบุรหัสไปรษณีย์'),
    address_current: yup.string().required('กรุณาระบุที่อยู่ปัจจุบัน'),
    province_current: yup.object().required('กรุณาระบุจังหวัด'),
    district_current: yup.object().required('กรุณาระบุเขต / อำเภอ'),
    sub_district_current: yup.object().required('กรุณาระบุแขวง / ตำบล '),
    post_code_current: yup.string().required('กรุณาระบุรหัสไปรษณีย์')
  })
  .required()
function FormPersonalDetailDetail({ orgId, code, btn_edit }) {
  const { t } = useTranslation()
  const {
    control,
    setValue,
    setError,
    handleSubmit,
    formState: { errors }
  } = useForm({
    resolver: yupResolver(schema)
  })
  const [dataDetail, setDataDetail] = useState()
  const empsTitle = UseEmpsTitle()
  const [empsTitleTH, setEmpsTitleTH] = useState([])
  const [empsTitleEng, setEmpsTitleEng] = useState([])
  const dataSexs = UseSexs()
  const nationalitys = UseNationalitys()

  const [provincIdHome, setProvincIdHome] = useState(0)
  const [districtIdHome, setDistrictIdHome] = useState(0)
  const [provincIdCurrent, setProvincIdCurrent] = useState(0)
  const [districtIdCurrent, setDistrictIdCurrent] = useState(0)

  const provinces = UseProvinces()
  const districts_first = UseDistricts(provincIdHome)
  const subDistricts_first = UseSubdistricts(districtIdHome)

  const cr_districts = UseDistricts(provincIdCurrent)
  const cr_subDistricts = UseSubdistricts(districtIdCurrent)

  const [isSave, setIsSave] = useState(false)
  const [isRead, setIsRead] = useState(true)

  const [idPassport, setIdPassport] = useState(1)
  const inputRef = useRef(null)
  const handleKeyDownTH = useThaiInput(inputRef)
  const handleKeyDownEN = useEngInput(inputRef)

  useEffect(() => {
    if (dataDetail && empsTitle.length > 0) {
      const newDataTH = empsTitle.map((d, i) => {
        return { value: d.id, label: d.th, id: d.id }
      })

      const newDataENG = empsTitle.map((d, i) => {
        return { value: d.id, label: d.en, id: d.id }
      })

      const titleTHNew = newDataTH.find((d) => d.label === dataDetail?.title_th)
      setValue('title_th', titleTHNew)
      const titleENNew = newDataENG.find(
        (d) => d.label === dataDetail?.title_en
      )
      setValue('title_en', titleENNew)

      setEmpsTitleTH(newDataTH)
      setEmpsTitleEng(newDataENG)
    }
  }, [empsTitle, dataDetail, setValue])

  // isSave is deliberately not a dependency: it flips twice per save, and this effect refetches
  // and setValue()s over every field, which would wipe what the user typed when a save fails.
  // provinces starts as [] (truthy) and is set to false when the API returns nothing, so check
  // length — a truthiness check fetches before provinces has loaded and the lookups below miss.
  useEffect(() => {
    if (nationalitys.length > 0 && provinces?.length > 0) {
      getEmpsPersonals({ orgId, code })
    }
  }, [code, nationalitys, orgId, provinces])

  const getEmpsPersonals = async (body) => {
    const result = await getEmpsPersonalsAPI(body)
    if (!result) return
    const res = result.result && result.result[0]

    setDataDetail(result.result[0])
    setIdPassport(res.type_id_card)
    setValue('post_code_current', res.post_code_current)
    setError('post_code_current', res.post_code_current)

    setValue('post_code_home', res.post_code_home)
    setError('post_code_home', res.post_code_home)

    setValue(
      'birthday',
      res.birthday !== '0000-00-00' && res.birthday
        ? moment(res.birthday).format('YYYY-MM-DD')
        : ''
    )
    setError(
      'birthday',
      res.birthday !== '0000-00-00' && res.birthday && res.birthday
    )

    setValue('personalemail', res.personal_email)
    setError('personalemail', res.personal_email)

    setValue('height', res.height)
    setError('height', res.height)

    setValue('id_card', res.id_card)
    setError('id_card', res.id_card)

    setValue('id_line', res.line_id)
    setError('id_line', res.line_id)

    setValue('mobile', res.phone)
    setError('mobile', res.phone)

    setValue('name_en', res.name_en)
    setError('name_en', res.name_en)

    setValue('name_th', res.name_th)
    setError('name_th', res.name_th)

    setValue('nickname_th', res.nickname_th)
    setError('nickname_th', res.nickname_th)

    setValue('nickname_en', res.nickname_en)
    setError('nickname_en', res.nickname_en)

    setValue('sex', { value: res.sex, label: res.sex })
    setError('sex', { value: res.sex, label: res.sex })

    setValue('surname_en', res.surname_en)
    setError('surname_en', res.surname_en)

    setValue('surname_th', res.surname_th)
    setError('surname_th', res.surname_th)

    setValue('title_en', res.title_en)
    setError('title_en', res.title_en)

    setValue('title_th', res.title_th)
    setError('title_th', res.title_th)
    const nationalitysNew = nationalitys.find(
      (d) => d.label === res.nationality
    )
    setValue('nationality', nationalitysNew)
    setError('nationality', nationalitysNew)

    setValue('weight', res.weight)
    setError('weight', res.weight)

    setValue('phone2', res.phone2)

    setValue('address_home', res.address_home)
    setError('address_home', res.address_home)

    setValue('address_current', res.address_current)
    setError('address_current', res.address_current)

    const province_homeNew = provinces.find(
      (d) => d.label === res.province_home
    )
    setProvincIdHome(province_homeNew?.value)

    setValue('province_home', province_homeNew)
    setError('province_home', province_homeNew)

    const province_crNew = provinces.find(
      (d) => d.label === res.province_current
    )
    setProvincIdCurrent(province_crNew?.value)

    setValue('province_current', province_crNew)
    setError('province_current', province_crNew)

    // setValue('licensePlate', res.license_plate)
    // setError('licensePlate', res.license_plate)
    let _car = res.license_plate_car?.split(',') ?? []
    setValue(
      'licensePlateCar',
      _car.map((d) => ({ label: d, value: d }))
    )
    let _moto = res.license_plate_moto?.split(',') ?? []

    setValue(
      'licensePlateMoto',
      _moto.map((d) => ({ label: d, value: d }))
    )

    if (provinces) {
      fnDistricts_current(res)
      fnDistricts_home(res)
    }
  }

  const fnDistricts_current = async (dv) => {
    const provinceNew = provinces.find((d) => d.label === dv.province_current)
    const res = await getDistrictsAPI(provinceNew?.value)
    if (!res) return

    if (res.result?.length > 0) {
      const cr_districtsNew = res.result.find(
        (d) => d.AMPHUR_NAME === dv.district_current
      )
      setValue('district_current', {
        value: cr_districtsNew?.AMPHUR_ID,
        label: cr_districtsNew?.AMPHUR_NAME
      })
      setError('district_current', cr_districtsNew)

      setDistrictIdCurrent(cr_districtsNew?.AMPHUR_ID)
      fnSub_district(cr_districtsNew?.AMPHUR_ID, dv)
    }
  }
  const fnDistricts_home = async (dv) => {
    const province_homeNew = provinces.find((d) => d.label === dv.province_home)
    const res = await getDistrictsAPI(province_homeNew?.value)
    if (!res) return

    if (res.result?.length > 0) {
      const districtsNew = res.result.find(
        (d) => d.AMPHUR_NAME === dv.district_home
      )
      setValue('district_home', {
        value: districtsNew?.AMPHUR_ID,
        label: districtsNew?.AMPHUR_NAME
      })
      setError('district_home', districtsNew)

      setDistrictIdHome(districtsNew?.AMPHUR_ID)
      fnSub_district_home(districtsNew?.AMPHUR_ID, dv)
    }
  }

  const fnSub_district = async (d, dv) => {
    if (d) {
      const res = await getSubdistrictsAPI(d)
      if (!res) return
      if (res.result.length > 0) {
        const cr_subDistrictsNew = res.result.find(
          (d) => d.DISTRICT_NAME === dv.sub_district_current
        )
        setValue('sub_district_current', {
          value: cr_subDistrictsNew?.DISTRICT_ID,
          label: cr_subDistrictsNew?.DISTRICT_NAME
        })
        setError('sub_district_current', cr_subDistrictsNew)
      }
    }
  }
  const fnSub_district_home = async (d, dv) => {
    if (d) {
      const res = await getSubdistrictsAPI(d)
      if (!res) return
      if (res.result.length > 0) {
        const sub_district_homeNew = res.result.find(
          (d) => d.DISTRICT_NAME === dv.sub_district_home
        )
        setValue('sub_district_home', {
          value: sub_district_homeNew?.DISTRICT_ID,
          label: sub_district_homeNew?.DISTRICT_NAME
        })
        setError('sub_district_home', sub_district_homeNew)
      }
    }
  }

  const onSubmit = (data) => {
    const d = data
    const formatMobileNumber = (mobile) => {
      if (!mobile) return ''
      const cleanedMobile = mobile.replace(/\D/g, '')
      return cleanedMobile.replace(/(\d{2})(\d{4})(\d{4})/, '$1 $2 $3')
    }
    const body = {
      titleEn: d.title_en?.label ?? '',
      nameEn: d.name_en ?? '',
      surnameEn: d.surname_en ?? '',
      nicknameEn: d.nickname_en ?? '',
      phone: formatMobileNumber(d.mobile) ?? '',

      email: d.email ?? '',
      lineId: d.id_line ?? '',
      typeId: d.empsTypes?.value ?? '',
      probationId: d.empProbations?.value ?? '',
      titleTh: d.title_th?.label ?? '',
      nameTh: d.name_th ?? '',
      surnameTh: d.surname_th ?? '',
      nicknameTh: d.nickname_th ?? '',
      idCard: d.id_card?.replace(/\s/g, '') ?? '',
      birthday: d.birthday ?? '',
      sex: d.sex?.value ?? '',
      nationality: d.nationality?.label ?? '',
      weight: d.weight ?? '', //float
      height: d.height ?? '', //float
      addressCurrent: d.address_current ?? '', //ที่อยู่ปัจจุบัน
      subDistCurrent: d.sub_district_current?.label ?? '',
      distCurrent: d.district_current?.label ?? '',
      provinceCurrent: d.province_current?.label,
      postCodeCurrent: d.post_code_current ?? '',
      addressHome: d.address_home ?? '',
      subDistHome: d.sub_district_home?.label ?? '',
      distHome: d.district_home?.label ?? '',
      provinceHome: d.province_home?.label ?? '',
      postCodeHome: d.post_code_home ?? '',

      personalEmail: d.personalemail ?? '',

      subDistCurrentId: d.sub_district_current.value,
      distCurrentId: d.district_current.value,
      provinceCurrentId: d.province_current.value,
      subDistHomeId: d.sub_district_home.value,
      distHomeId: d.district_home.value,
      provinceHomeId: d.province_home.value,
      typeIdCard: idPassport,
      phone2: d.phone2,
      // licensePlate: d.licensePlate ?? '',
      licensePlateCar: d.licensePlateCar?.map((_) => _.value).join(','),
      licensePlateMoto: d.licensePlateMoto?.map((_) => _.value).join(',')
    }

    SwalCustom({
      title: 'Are you sure?',
      text: 'Do you want to save the changes?',
      icon: 'question',
      showCancelButton: true,
      confirmButtonColor: 'var(--comp-badge-color-background-primary)',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, save it!'
    }).then((result) => {
      if (result.isConfirmed) {
        setIsSave(true)
        updateEmps(body)
      }
    })
  }
  const updateEmps = async (data) => {
    const result = await updateEmpsPersonalsAPI({ orgId, code }, data)
    setIsSave(false)
    setIsRead(false)
    if (!result) return
    if (isLarkSyncWarning(result?.msg)) {
      SwalLarkSyncWarning(t, result?.msg).then(() => {
        setIsRead(true)
        getEmpsPersonals({ orgId, code })
      })
      return
    }
    if (result?.status) {
      SwalCustom({
        title: `Success!`,
        text: TXTSUCCESS,
        timer: 1500,
        showConfirmButton: false
      }).then(() => {
        setIsRead(true)
        getEmpsPersonals({ orgId, code })
      })
    } else {
      Error_false(result)
    }
  }

  const fnCancle = () => {
    getEmpsPersonals({ orgId, code })
  }

  const options = { uppercase: true, numericOnly: true }

  return (
    <Form onSubmit={handleSubmit(onSubmit)}>
      <Row style={{ rowGap: '15px' }}>
        <Col xl={12} className="d-flex justify-content-between">
          <span className="my-auto text-primary">Personal Details</span>
          {btn_edit && (
            <ButtonSummit
              fnCancle={fnCancle}
              isRead={isRead}
              setIsRead={setIsRead}
              isSave={isSave}
              handleSubmit={handleSubmit(onSubmit)}
            />
          )}
        </Col>

        <ColFrom>
          <LabelCustomSmall
            className={`${isRead === false ? 'fw-light' : 'fw-bold'}`}
          >
            คำนำหน้า
          </LabelCustomSmall>
          {isRead === false ? (
            <Controller
              name={'title_th'}
              control={control}
              render={({ field: { value = '' } }) => (
                <Autocomplete
                  options={empsTitleTH}
                  value={value}
                  disabled={isRead}
                  onChange={(d) => {
                    setValue('title_th', d)

                    const titleENNew = empsTitleEng.find(
                      (dt) => dt.id === d?.id
                    )
                    setValue('title_en', titleENNew)

                    setError('title_th', d)
                    setError('title_en', titleENNew)
                  }}
                />
              )}
            />
          ) : (
            <div className="fw-light small">{dataDetail?.title_th ?? '-'}</div>
          )}
          {errors.title_th?.message && (
            <label className="small text-danger">
              {errors.title_th.message}
            </label>
          )}
        </ColFrom>
        <ColFrom>
          <LabelCustomSmall
            className={`${isRead === false ? 'fw-light' : 'fw-bold'}`}
          >
            ชื่อ
          </LabelCustomSmall>
          {isRead === false ? (
            <Controller
              name={'name_th'}
              control={control}
              render={({ field: { onChange, value = '' } }) => (
                <Form.Control
                  disabled={isRead}
                  value={value}
                  onChange={onChange}
                  ref={inputRef}
                  onKeyDown={handleKeyDownTH}
                />
              )}
            />
          ) : (
            <div className="fw-light small">{dataDetail?.name_th ?? '-'}</div>
          )}

          {errors.name_th?.message && (
            <label className="small text-danger">
              {errors.name_th.message}
            </label>
          )}
        </ColFrom>
        <ColFrom>
          <LabelCustomSmall
            className={`${isRead === false ? 'fw-light' : 'fw-bold'}`}
          >
            นามสกุล
          </LabelCustomSmall>
          {isRead === false ? (
            <Controller
              name={'surname_th'}
              control={control}
              render={({ field: { onChange, value = '' } }) => (
                <Form.Control
                  disabled={isRead}
                  value={value}
                  onChange={onChange}
                  ref={inputRef}
                  onKeyDown={handleKeyDownTH}
                />
              )}
            />
          ) : (
            <div className="fw-light small">
              {dataDetail?.surname_th ?? '-'}
            </div>
          )}

          {errors.surname_th?.message && (
            <label className="small text-danger">
              {errors.surname_th.message}
            </label>
          )}
        </ColFrom>
        <ColFrom>
          <LabelCustomSmall
            className={`${isRead === false ? 'fw-light' : 'fw-bold'}`}
          >
            ชื่อเล่น
          </LabelCustomSmall>
          {isRead === false ? (
            <Controller
              name={'nickname_th'}
              control={control}
              render={({ field: { onChange, value = '' } }) => (
                <Form.Control
                  disabled={isRead}
                  value={value}
                  onChange={onChange}
                  ref={inputRef}
                  onKeyDown={handleKeyDownTH}
                />
              )}
            />
          ) : (
            <div className="fw-light small">
              {dataDetail?.nickname_th ?? '-'}
            </div>
          )}

          {errors.nickname_th?.message && (
            <label className="small text-danger">
              {errors.nickname_th.message}
            </label>
          )}
        </ColFrom>
        <ColFrom>
          <LabelCustomSmall
            className={`${isRead === false ? 'fw-light' : 'fw-bold'}`}
          >
            Prefix
          </LabelCustomSmall>
          {isRead === false ? (
            <Controller
              name={'title_en'}
              control={control}
              render={({ field: { value = '' } }) => (
                <Autocomplete
                  options={empsTitleEng}
                  disabled={isRead}
                  value={value}
                  onChange={(d) => {
                    setValue('title_en', d)
                    const titleENNew = empsTitleTH.find((dt) => dt.id === d?.id)
                    setValue('title_th', titleENNew)

                    setError('title_th', false)
                    setError('title_en', false)
                  }}
                />
              )}
            />
          ) : (
            <div className="fw-light small">{dataDetail?.title_en ?? '-'}</div>
          )}

          {errors.title_en?.message && (
            <label className="small text-danger">
              {errors.title_en.message}
            </label>
          )}
        </ColFrom>
        <ColFrom>
          <LabelCustomSmall
            className={`${isRead === false ? 'fw-light' : 'fw-bold'}`}
          >
            Name
          </LabelCustomSmall>
          {isRead === false ? (
            <Controller
              name={'name_en'}
              control={control}
              render={({ field: { onChange, value = '' } }) => (
                <Form.Control
                  disabled={isRead}
                  value={value}
                  onChange={onChange}
                  ref={inputRef}
                  onKeyDown={handleKeyDownEN}
                />
              )}
            />
          ) : (
            <div className="fw-light small">{dataDetail?.name_en ?? '-'}</div>
          )}

          {errors.name_en?.message && (
            <label className="small text-danger">
              {errors.name_en.message}
            </label>
          )}
        </ColFrom>
        <ColFrom>
          <LabelCustomSmall
            className={`${isRead === false ? 'fw-light' : 'fw-bold'}`}
          >
            Surname
          </LabelCustomSmall>
          {isRead === false ? (
            <Controller
              name={'surname_en'}
              control={control}
              render={({ field: { onChange, value = '' } }) => (
                <Form.Control
                  disabled={isRead}
                  value={value}
                  onChange={onChange}
                  ref={inputRef}
                  onKeyDown={handleKeyDownEN}
                />
              )}
            />
          ) : (
            <div className="fw-light small">
              {dataDetail?.surname_en ?? '-'}
            </div>
          )}

          {errors.surname_en?.message && (
            <label className="small text-danger">
              {errors.surname_en.message}
            </label>
          )}
        </ColFrom>

        <ColFrom>
          <LabelCustomSmall
            className={`${isRead === false ? 'fw-light' : 'fw-bold'}`}
          >
            Nickname
          </LabelCustomSmall>
          {isRead === false ? (
            <Controller
              name={'nickname_en'}
              control={control}
              render={({ field: { onChange, value = '' } }) => (
                <Form.Control
                  disabled={isRead}
                  value={value}
                  onChange={onChange}
                  ref={inputRef}
                  onKeyDown={handleKeyDownEN}
                />
              )}
            />
          ) : (
            <div className="fw-light small">
              {dataDetail?.nickname_en ?? '-'}
            </div>
          )}

          {errors.nickname_en?.message && (
            <label className="small text-danger">
              {errors.nickname_en.message}
            </label>
          )}
        </ColFrom>
        <Col xl={12}>
          <div className="border-bottom mt-3 mb-3"> </div>
        </Col>
        <ColFrom>
          <LabelCustomSmall
            className={`${isRead === false ? 'fw-light' : 'fw-bold'}`}
          >
            วันเกิด (ค.ศ.)
          </LabelCustomSmall>
          {isRead === false ? (
            <Controller
              name={'birthday'}
              control={control}
              render={({ field: { value = '' } }) => (
                <DatepickerCustom
                  value={value}
                  disabled={isRead}
                  onChange={([date]) => {
                    setValue(
                      'birthday',
                      date ? moment(date).format('YYYY-MM-DD') : ''
                    )
                    setError('birthday', date)
                  }}
                />
              )}
            />
          ) : (
            <div className="fw-light small">
              {dataDetail && dataDetail.birthday
                ? moment(dataDetail.birthday, 'YYYY-MM-DD', true).isValid()
                  ? moment(dataDetail.birthday)
                      // .add(543, 'year')
                      .format('DD/MM/YYYY')
                  : '-'
                : '-'}
            </div>
          )}

          {errors.birthday?.message && (
            <label className="small text-danger">
              {errors.birthday.message}
            </label>
          )}
        </ColFrom>
        <ColFrom>
          <LabelCustomSmall
            className={`${isRead === false ? 'fw-light' : 'fw-bold'}`}
          >
            เพศ
          </LabelCustomSmall>
          {isRead === false ? (
            <Controller
              name={'sex'}
              control={control}
              render={({ field: { onChange, value = '' } }) => (
                <Autocomplete
                  disabled={isRead}
                  options={dataSexs}
                  value={value}
                  onChange={onChange}
                />
              )}
            />
          ) : (
            <div className="fw-light small">{dataDetail?.sex ?? '-'}</div>
          )}

          {errors.sex?.message && (
            <label className="small text-danger">{errors.sex.message}</label>
          )}
        </ColFrom>
        <ColFrom>
          <LabelCustomSmall
            className={`${isRead === false ? 'fw-light' : 'fw-bold'}`}
          >
            ส่วนสูง
          </LabelCustomSmall>
          {isRead === false ? (
            <Controller
              name={'height'}
              control={control}
              render={({ field: { onChange, value = '' } }) => (
                <Form.Control
                  disabled={isRead}
                  type="number"
                  value={value}
                  onChange={onChange}
                />
              )}
            />
          ) : (
            <div className="fw-light small">{dataDetail?.height ?? '-'}</div>
          )}

          {errors.height?.message && (
            <label className="small text-danger">{errors.height.message}</label>
          )}
        </ColFrom>
        <ColFrom>
          <LabelCustomSmall
            className={`${isRead === false ? 'fw-light' : 'fw-bold'}`}
          >
            น้ำหนัก
          </LabelCustomSmall>
          {isRead === false ? (
            <Controller
              name={'weight'}
              control={control}
              render={({ field: { onChange, value = '' } }) => (
                <Form.Control
                  disabled={isRead}
                  type="number"
                  value={value}
                  onChange={onChange}
                />
              )}
            />
          ) : (
            <div className="fw-light small">{dataDetail?.weight ?? '-'}</div>
          )}

          {errors.weight?.message && (
            <label className="small text-danger">{errors.weight.message}</label>
          )}
        </ColFrom>
        <ColFrom>
          <LabelCustomSmall
            className={`${isRead === false ? 'fw-light' : 'fw-bold'}`}
          >
            สัญชาติ
          </LabelCustomSmall>
          {isRead === false ? (
            <Controller
              name={'nationality'}
              control={control}
              render={({ field: { value = '', onChange } }) => (
                <Autocomplete
                  disabled={isRead}
                  options={nationalitys}
                  value={value}
                  onChange={onChange}
                />
              )}
            />
          ) : (
            <div className="fw-light small">
              {dataDetail?.nationality ?? '-'}
            </div>
          )}

          {errors.nationality?.message && (
            <label className="small text-danger">
              {errors.nationality.message}
            </label>
          )}
        </ColFrom>
        <ColFrom>
          {isRead ? (
            <label>
              <span
                className={`fw-bold small ${
                  idPassport === 2 ? 'opacity-25' : ''
                }`}
                // onClick={() => setIdPassport(1)}
              >
                เลขประจำตัวประชาชน
              </span>
              <span className="opacity-25">/</span>
              <span
                className={` fw-bold small ${
                  idPassport === 1 ? 'opacity-25' : ''
                }`}
                // onClick={() => setIdPassport(2)}
              >
                เลขพาสปอร์ต
              </span>
            </label>
          ) : (
            <label className="pointer-event">
              <span
                className={`fw-bold small ${
                  idPassport === 2 ? 'opacity-25' : ''
                }`}
                onClick={() => setIdPassport(1)}
              >
                เลขประจำตัวประชาชน
              </span>
              <span className="opacity-25">/</span>
              <span
                className={` fw-bold small ${
                  idPassport === 1 ? 'opacity-25' : ''
                }`}
                onClick={() => setIdPassport(2)}
              >
                เลขพาสปอร์ต
              </span>
            </label>
          )}
          {isRead === false ? (
            <Controller
              name={'id_card'}
              control={control}
              render={({ field: { value = '', onChange } }) =>
                idPassport === 2 ? (
                  <InputNumber
                    disabled={isRead}
                    value={value}
                    onChange={onChange}
                  />
                ) : (
                  <InputIDCardNumber
                    disabled={isRead}
                    value={value}
                    onChange={onChange}
                  />
                )
              }
            />
          ) : (
            <div className="fw-light small">
              {/* {dataDetail?.typeIdCard === 1 ? (

              )
} */}
              {dataDetail?.id_card ?? '-'}
            </div>
          )}

          {errors.id_card?.message && (
            <label className="small text-danger">
              {errors.id_card.message}
            </label>
          )}
          {/* <LabelCustomSmall>
            เลขประจำตัวประชาชน/พาสปอร์ต (passport)
          </LabelCustomSmall>
          <Controller
            name={'id_card'}
            control={control}
            render={({ field: { onChange, value = '' } }) => (
              <InputNumber
                disabled={isRead}
                value={value}
                onChange={onChange}
              />
            )}
          />
          {errors.id_card?.message && (
            <label className="small text-danger">
              {errors.id_card.message}
            </label>
          )} */}
        </ColFrom>

        <Col xl={12}>
          <div className="border-bottom mt-3 mb-3"> </div>
        </Col>
        <ColFrom>
          <LabelCustomSmall
            className={`${isRead === false ? 'fw-light' : 'fw-bold'}`}
          >
            Personal Email{' '}
            {isRead === false ? (
              <span className="text-warning">(ถ้ามี)</span>
            ) : (
              <></>
            )}{' '}
          </LabelCustomSmall>
          {isRead === false ? (
            <Controller
              name={'personalemail'}
              control={control}
              render={({ field: { onChange, value = '' } }) => (
                <Form.Control
                  disabled={isRead}
                  type="email"
                  value={value}
                  onChange={onChange}
                />
              )}
            />
          ) : (
            <div className="fw-light small">
              {dataDetail?.personal_email ?? '-'}
            </div>
          )}

          {errors.personalemail?.message && (
            <label className="small text-danger">
              {errors.personalemail.message}
            </label>
          )}
        </ColFrom>
        <ColFrom>
          <LabelCustomSmall
            className={`${isRead === false ? 'fw-light' : 'fw-bold'}`}
          >
            หมายเลขโทรศัพท์ (มือถือ)
          </LabelCustomSmall>
          {isRead === false ? (
            <Controller
              name={'mobile'}
              control={control}
              render={({ field: { onChange, value = '' } }) => (
                <Form.Control
                  maxLength={12}
                  disabled={isRead}
                  value={value}
                  onChange={onChange}
                />
                // <InputPhonePersonal
                //   disabled={isRead}
                //   value={value}
                //   onChange={onChange}
                // />
              )}
            />
          ) : (
            <div className="fw-light small">{dataDetail?.phone ?? '-'}</div>
          )}

          {errors.mobile?.message && (
            <label className="small text-danger">{errors.mobile.message}</label>
          )}
        </ColFrom>
        <ColFrom>
          <LabelCustomSmall
            className={`${isRead === false ? 'fw-light' : 'fw-bold'}`}
          >
            เบอร์มือถือออฟฟิศ{' '}
            {!isRead && <span className="text-warning"> (ถ้ามี)</span>}{' '}
          </LabelCustomSmall>
          {isRead === false ? (
            <Controller
              name={'phone2'}
              control={control}
              render={({ field: { onChange, value = '' } }) => (
                <Form.Control
                  maxLength={12}
                  disabled={isRead}
                  value={value}
                  onChange={onChange}
                />
              )}
            />
          ) : (
            <div className="fw-light small">{dataDetail?.phone2 ?? '-'}</div>
          )}

          {errors.phone2?.message && (
            <label className="small text-danger">{errors.phone2.message}</label>
          )}
        </ColFrom>
        <ColFrom>
          <LabelCustomSmall
            className={`${isRead === false ? 'fw-light' : 'fw-bold'}`}
          >
            LINE ID{' '}
            {isRead === false ? (
              <span className="text-warning"> (ถ้ามี)</span>
            ) : (
              <></>
            )}{' '}
          </LabelCustomSmall>
          {isRead === false ? (
            <Controller
              name={'id_line'}
              control={control}
              render={({ field: { onChange, value = '' } }) => (
                <Form.Control
                  disabled={isRead}
                  value={value}
                  onChange={onChange}
                />
              )}
            />
          ) : (
            <div className="fw-light small">{dataDetail?.line_id ?? '-'}</div>
          )}
        </ColFrom>
        <ColFrom>
          <LabelCustomSmall
            className={`${isRead === false ? 'fw-light' : 'fw-bold'}`}
          >
            ป้ายทะเบียนรถยนต์
            {!isRead && <span className="text-warning"> (ถ้ามี)</span>}{' '}
          </LabelCustomSmall>

          {!isRead ? (
            <Controller
              name={'licensePlateCar'}
              control={control}
              render={({ field: { onChange, value } }) => (
                <CreatableSelectLicenseCustom
                  maxLength={2}
                  value={value}
                  onChange={onChange}
                />
              )}
            />
          ) : (
            <div className="fw-light small">
              {dataDetail?.license_plate_car ?? '-'}
            </div>
          )}
        </ColFrom>
        <ColFrom>
          <LabelCustomSmall
            className={`${isRead === false ? 'fw-light' : 'fw-bold'}`}
          >
            ป้ายทะเบียนรถจักรยานยนต์
            {!isRead && <span className="text-warning"> (ถ้ามี)</span>}{' '}
          </LabelCustomSmall>

          {!isRead ? (
            <Controller
              name={'licensePlateMoto'}
              control={control}
              render={({ field: { onChange, value } }) => (
                <CreatableSelectLicenseCustom
                  maxLength={2}
                  value={value}
                  onChange={onChange}
                />
              )}
            />
          ) : (
            <div className="fw-light small">
              {dataDetail?.license_plate_moto ?? '-'}
            </div>
          )}
        </ColFrom>

        <Col xl={12}>
          <div className="border-bottom mt-3 mb-3"> </div>
        </Col>
        <ColFrom>
          <LabelCustomSmall
            className={`${isRead === false ? 'fw-light' : 'fw-bold'}`}
          >
            ที่อยู่ตามทะเบียนบ้าน
          </LabelCustomSmall>
          {isRead === false ? (
            <Controller
              name={'address_home'}
              control={control}
              render={({ field: { value = '', onChange } }) => (
                <Form.Control
                  disabled={isRead}
                  value={value}
                  onChange={onChange}
                />
              )}
            />
          ) : (
            <div className="fw-light small">
              {dataDetail?.address_home ?? '-'}
            </div>
          )}

          {errors.address_home?.message && (
            <label className="small text-danger">
              {errors.address_home.message}
            </label>
          )}
        </ColFrom>
        <ColFrom>
          <LabelCustomSmall
            className={`${isRead === false ? 'fw-light' : 'fw-bold'}`}
          >
            จังหวัด
          </LabelCustomSmall>
          {isRead === false ? (
            <Controller
              name={'province_home'}
              control={control}
              render={({ field: { value = {} } }) => (
                <Autocomplete
                  disabled={isRead}
                  maxLength={300}
                  value={value}
                  options={provinces}
                  onChange={(d) => {
                    setProvincIdHome(d.value)
                    setValue('province_home', d)
                    setError('province_home', false)

                    setValue('district_home')
                    setError('district_home', true)

                    setValue('sub_district_home')
                    setError('sub_district_home', true)

                    setValue('post_code_home', '')
                    setError('post_code_home', true)
                  }}
                />
              )}
            />
          ) : (
            <div className="fw-light small">
              {dataDetail?.province_home ?? '-'}
            </div>
          )}

          {errors.province_home?.message && (
            <label className="small text-danger">
              {errors.province_home.message}
            </label>
          )}
        </ColFrom>
        <ColFrom>
          <LabelCustomSmall
            className={`${isRead === false ? 'fw-light' : 'fw-bold'}`}
          >
            อำเภอ/เขต
          </LabelCustomSmall>
          {isRead === false ? (
            <Controller
              name={'district_home'}
              control={control}
              render={({ field: { value = {} } }) => (
                <Autocomplete
                  value={value}
                  disabled={!isRead ? (provincIdHome > 0 ? false : true) : true}
                  options={districts_first}
                  onChange={(d) => {
                    setDistrictIdHome(d.value)
                    setValue('district_home', d)
                    setError('district_home', false)

                    setValue('sub_district_home')
                    setError('sub_district_home', true)
                    setValue('post_code_home', '')
                    setError('post_code_home', true)
                  }}
                />
              )}
            />
          ) : (
            <div className="fw-light small">
              {dataDetail?.district_home ?? '-'}
            </div>
          )}

          {errors.district_home?.message && (
            <label className="small text-danger">
              {errors.district_home.message}
            </label>
          )}
        </ColFrom>
        <ColFrom>
          <LabelCustomSmall
            className={`${isRead === false ? 'fw-light' : 'fw-bold'}`}
          >
            ตำบล/แขวง
          </LabelCustomSmall>
          {isRead === false ? (
            <Controller
              name={'sub_district_home'}
              control={control}
              render={({ field: { value = {} } }) => (
                <Autocomplete
                  value={value}
                  disabled={
                    !isRead ? (districtIdHome > 0 ? false : true) : true
                  }
                  options={subDistricts_first}
                  onChange={(d) => {
                    setValue('post_code_home', d.code)
                    setError('post_code_home', false)
                    setValue('sub_district_home', d)
                    setError('sub_district_home', false)
                  }}
                />
              )}
            />
          ) : (
            <div className="fw-light small">
              {dataDetail?.sub_district_home ?? '-'}
            </div>
          )}

          {errors.sub_district_home?.message && (
            <label className="small text-danger">
              {errors.sub_district_home.message}
            </label>
          )}
        </ColFrom>

        <ColFrom>
          <LabelCustomSmall
            className={`${isRead === false ? 'fw-light' : 'fw-bold'}`}
          >
            รหัสไปรษณีย์
          </LabelCustomSmall>
          {isRead === false ? (
            <Controller
              name={'post_code_home'}
              control={control}
              render={({ field: { value = '', onChange } }) => (
                <Cleave
                  className="form-control"
                  disabled={isRead}
                  value={value}
                  onChange={onChange}
                  options={options}
                  id="prefix"
                  maxLength={5}
                />
                // <Form.Control
                //   disabled={isRead}
                //   value={value}
                //   onChange={onChange}
                // />
              )}
            />
          ) : (
            <div className="fw-light small">
              {dataDetail?.post_code_home ?? '-'}
            </div>
          )}

          {errors.post_code_home?.message && (
            <label className="small text-danger">
              {errors.post_code_home.message}
            </label>
          )}
        </ColFrom>

        <Col xl={12}>
          <div className="border-bottom mt-3 mb-3"> </div>
        </Col>
        <ColFrom>
          <LabelCustomSmall
            className={`${isRead === false ? 'fw-light' : 'fw-bold'}`}
          >
            ที่อยู่ปัจจุบัน
          </LabelCustomSmall>
          {isRead === false ? (
            <Controller
              name={'address_current'}
              control={control}
              render={({ field: { value = '', onChange } }) => (
                <Form.Control
                  disabled={isRead}
                  maxLength={300}
                  value={value}
                  onChange={onChange}
                />
              )}
            />
          ) : (
            <div className="fw-light small">
              {dataDetail?.address_current ?? '-'}
            </div>
          )}

          {errors.address_current?.message && (
            <label className="small text-danger">
              {errors.address_current.message}
            </label>
          )}
        </ColFrom>

        <ColFrom>
          <LabelCustomSmall
            className={`${isRead === false ? 'fw-light' : 'fw-bold'}`}
          >
            จังหวัด
          </LabelCustomSmall>
          {isRead === false ? (
            <Controller
              name={'province_current'}
              control={control}
              render={({ field: { value = {} } }) => (
                <Autocomplete
                  value={value}
                  options={provinces}
                  disabled={isRead}
                  onChange={(d) => {
                    setProvincIdCurrent(d.value)
                    setValue('province_current', d)
                    setError('province_current', false)

                    setValue('district_current')
                    setError('district_current', true)

                    setValue('post_code_current', '')
                    setError('post_code_current', true)

                    setValue('sub_district_current')
                    setError('sub_district_current', true)
                  }}
                />
              )}
            />
          ) : (
            <div className="fw-light small">
              {dataDetail?.province_current ?? '-'}
            </div>
          )}

          {errors.province_current?.message && (
            <label className="small text-danger">
              {errors.province_current.message}
            </label>
          )}
        </ColFrom>
        <ColFrom>
          <LabelCustomSmall
            className={`${isRead === false ? 'fw-light' : 'fw-bold'}`}
          >
            อำเภอ/เขต
          </LabelCustomSmall>
          {isRead === false ? (
            <Controller
              name={'district_current'}
              control={control}
              render={({ field: { value = {} } }) => (
                <Autocomplete
                  value={value}
                  disabled={
                    !isRead ? (provincIdCurrent > 0 ? false : true) : true
                  }
                  options={cr_districts}
                  onChange={(d) => {
                    setDistrictIdCurrent(d.value)
                    setValue('district_current', d)
                    setError('district_current', false)

                    setValue('sub_district_current')
                    setError('sub_district_current', false)

                    setValue('post_code_current', '')
                    setError('post_code_current', false)
                  }}
                />
              )}
            />
          ) : (
            <div className="fw-light small">
              {dataDetail?.district_current ?? '-'}
            </div>
          )}

          {errors.district_current?.message && (
            <label className="small text-danger">
              {errors.district_current.message}
            </label>
          )}
        </ColFrom>
        <ColFrom>
          <LabelCustomSmall
            className={`${isRead === false ? 'fw-light' : 'fw-bold'}`}
          >
            ตำบล/แขวง
          </LabelCustomSmall>
          {isRead === false ? (
            <Controller
              name={'sub_district_current'}
              control={control}
              render={({ field: { value = {} } }) => (
                <Autocomplete
                  value={value}
                  disabled={
                    !isRead ? (districtIdCurrent > 0 ? false : true) : true
                  }
                  options={cr_subDistricts}
                  onChange={(d) => {
                    setValue('post_code_current', d.code)
                    setError('post_code_current', false)

                    setValue('sub_district_current', d)
                    setError('sub_district_current', false)
                  }}
                />
              )}
            />
          ) : (
            <div className="fw-light small">
              {dataDetail?.sub_district_current ?? '-'}
            </div>
          )}

          {errors.sub_district_current?.message && (
            <label className="small text-danger">
              {errors.sub_district_current.message}
            </label>
          )}
        </ColFrom>
        <ColFrom>
          <LabelCustomSmall
            className={`${isRead === false ? 'fw-light' : 'fw-bold'}`}
          >
            รหัสไปรษณีย์
          </LabelCustomSmall>
          {isRead === false ? (
            <Controller
              name={'post_code_current'}
              control={control}
              render={({ field: { value = '', onChange } }) => (
                <Cleave
                  className="form-control"
                  disabled={isRead}
                  value={value}
                  onChange={onChange}
                  options={options}
                  id="prefix"
                  maxLength={5}
                />
                // <Form.Control
                //   disabled={isRead}
                //   value={value}
                //   onChange={onChange}
                // />
              )}
            />
          ) : (
            <div className="fw-light small">
              {dataDetail?.post_code_current ?? '-'}
            </div>
          )}

          {errors.post_code_current?.message && (
            <label className="small text-danger">
              {errors.post_code_current.message}
            </label>
          )}
        </ColFrom>
      </Row>
    </Form>
  )
}

const ColFrom = (props) => {
  const { children, className, ...other } = props

  return (
    <Col xl={3} xs={6} md={4} className={` ${className}`} {...other}>
      {children}
    </Col>
  )
}
export default FormPersonalDetailDetail
